import { getUrlArray } from '../vendor/url-helper-functions';
import { smartPushState } from '../vendor/evented-history-state-functions';

(function($) {
	try {
		// Ensure jQuery is available
		if (typeof $ === 'undefined') {

			return;
		}

		var $qandas = $(".qanda");
		var $qandaFilters = $(".qandas .filter-list a");



		$qandas.find('.question').on("click", function(e) {
			try {
				var $this = $(this).closest('.qanda');
				var slug = $this.data("slug");
				var filter = $this.data("q-and-as").trim();
				var filterby = "q-and-as";



				if($this.hasClass('has-been-active')){
					$this.removeClass('has-been-active');
					$this.removeClass('is-active');
				}else if ($this.hasClass("is-active")) {
					smartPushState(filterby, filter);
				} else {
					smartPushState(filterby, filter, slug);
				}
			} catch (error) {

			}
		});

		// Prevent clicks on answer area from closing the accordion
		$qandas.find('.answer').on("click", function(e) {
			e.stopPropagation();
		});

		$qandaFilters.on("click", function(e) {
			try {
				e.preventDefault();
				var $this = $(this);
				var filter = $this.data("value").trim();
				var filterby = $this.data("filterby");



				// Update URL and trigger filter
				smartPushState(filterby, filter);

				// Manually trigger the filter function
				filterQandas(filterby, filter);
			} catch (error) {

			}
		});

		var urlArray = getUrlArray();


		// Add defensive programming to prevent undefined errors
		if (urlArray && urlArray.length === 4) {

			//we are at the page level with no additonal path or slug as the url only contains 4 parts
			//trigger first filter
			$(".qandas .filter-list li:first-child a").trigger("click");
		}
	} catch (error) {

	}
})(jQuery);

export function filterQandas(filterby, filter, slug) {
	try {


		// Ensure jQuery is available
		if (typeof jQuery === 'undefined') {

			return;
		}

		var $qandas = jQuery(".qanda");
		var $qandaFilters = jQuery(".qandas .filter-list a");

		//activate filter
		$qandaFilters.removeClass("is-active");
		$qandaFilters.filter("[data-value='" + filter + "']").addClass("is-active");

		//filter quandas
		$qandas.removeClass("is-visible");
		$qandas.removeClass("is-active");

		jQuery(".filter-item[data-" + filterby + "*='" + filter + "']").addClass("is-visible");

		if (slug) {
			$qandas.filter("[data-slug='" + slug + "']").addClass("is-active");
			$qandas.filter("[data-slug='" + slug + "']").addClass("has-been-active");
		}


	} catch (error) {

	}
}
